import React from 'react';
import GameHeader from '../games/game-header';
import { global_var } from '../../services/cs-lab-config';

const TuxPaint = () => {

  document.title = "CS Lab | Tux Paint";

  return (
    <div className="container-fluid p-0">
      <div className="row mt-1">
        <div className="col">
          <GameHeader headerName="Tux Paint" />
          <iframe
            id="tuxPaintIframe"
            src={global_var.TUX_PAINT_ENDPOINT + '?token=' + sessionStorage.getItem('token')}
            title="Tux Paint"
            style={{
              width: '100%',
              height: '100vh',
              border: 'none',
            }}
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default TuxPaint;
